<!-- 安排评委 -->
<template>
  <div class="arrangeJudges">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col :span="6"> 考试名称：{{ $route.params.name }} </el-col>
      <el-col :span="1">
        <el-button
          :type="inputIsShow ? 'primary' : 'warning'"
          size="small"
          @click="submitBut"
          >{{ inputIsShow ? "保存" : "修改" }}</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      style="width: 100%;"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      :height="$store.getters.getTableHeight - 10"
    >
      <el-table-column
        prop="examSiteName"
        label="考点"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="subjectLevel"
        label="等级"
        align="center"
      ></el-table-column>
      <el-table-column label="评委" align="center">
        <template slot-scope="scope">
          <el-select
            v-if="inputIsShow"
            style="width:95%"
            v-model="scope.row.examAdjustIds"
            filterable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in judgesList"
              :key="item.userId"
              :label="item.userName + '-' + item.name"
              :value="item.userId"
            >
            </el-option>
          </el-select>
          <div v-else>
            <span v-for="item in scope.row.examAdjustVOS" :key="item.userId"
              >{{ item.userName + "-" + item.name }},</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableList: [],
      judgesList: [],
      tableIsLoad: false,
      infoId: null,
      inputIsShow: false,
    };
  },
  created() {
    if (!this.$route.params.id) {
      this.$router.go(-1);
      this.$message({ type: "warning", message: "id已过期,请重新查看!" ,duration:1000});
    }
    this.infoId = this.$route.params.id;
    this.tableLoad();
    this.judgesListLoad();
  },
  methods: {
    tableLoad() {
      this.$axios
        .get("/process/arrangeInfo?examId=" + this.infoId)
        .then((res) => {
          let data = res.data.data;
          this.tableList = data;
          this.tableIsLoad = false;
        });
    },
    judgesListLoad() {
      this.$axios.get("/process/queryJudge").then((res) => {
        let data = res.data.data;
        this.judgesList = data;
      });
    },
    operatInfo(type, row) {
      this.$emit("goTo", type === 1 ? "arrangeJudges" : "examInfo", row);
    },
    submitBut() {
      if (this.inputIsShow) {
        if (
          this.tableList.find((item) => {
            return item.examAdjustIds.length === 0;
          })
        ) {
          this.$dailog({
            title: "安排评委",
            context: "还有未安排评委的考点，是否继续保存?",
            callbackFun: () => {
              this.submitFun(1);
            },
          });
          return;
        }
        //保存
        this.submitFun(0);
      } else {
        this.inputIsShow = true;
      }
    },
    submitFun(status) {
      this.$axios
        .post("/process/arrange?status=" + status, this.tableList)
        .then((res) => {
          this.$message({ type: "success", message: '保存成功!' ,duration:1000});
          this.tableLoad();
          this.inputIsShow = false;
        });
    },
  },
};
</script>
